import Card from "@mui/material/Card";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import { SvgIconComponent } from "@mui/icons-material";

interface OutlineButtonProps {
  cardName: string;
  Icon: SvgIconComponent;
}

const OutlineButton = ({ cardName, Icon }: OutlineButtonProps) => (
  <Card
    className="flex items-center justify-between w-full px-4 py-3 cursor-pointer border border-gray-300 "
    style={{ overflow: "hidden" }}
  >
    {/* Left Icon + Text */}
    <div className="flex items-center gap-3">
      <Icon fontSize="small" />
      <p className="text-sm font-semibold">{cardName}</p>
    </div>

    {/* Right Arrow */}
    <ArrowForwardIosIcon fontSize="small" />
  </Card>
);

export default OutlineButton;
